var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bulk-paymethod-whitelist',{attrs:{"is-loading":_vm.isLoading,"paymethods":_vm.paymethods},on:{"project-selected":_vm.loadPaymethods,"bulk-update":_vm.onBulkUpdateWhitelist,"whitelist-all":_vm.onWhitelistAll}})
}
var staticRenderFns = []

export { render, staticRenderFns }